import {
	OTHER_INTEGRATIONS_SUCCESS,OTHER_INTEGRATIONS_ERROR
} from "../../constants/Integrations/Integrations.type";
import createReducer from "../../../utils/createReducer";
const initialState = {
	isLoading: true,
	integrateService: [],
	errorStatus: false,
	errorMsgs: '',
};
const OtherIntegrations = function reducerObj(state = initialState, action = {}) {
	const { type, payload } = action;
	switch (type) {
		case OTHER_INTEGRATIONS_SUCCESS:
			return {
				...state,
				isLoading: false,
                integrateService:payload
			};
        case OTHER_INTEGRATIONS_ERROR:
            return {
                ...state,
                isLoading: false,
                errorStatus: true,
	            errorMsgs: payload,
            };

		default:
			return state;
	}
}
export default OtherIntegrations;
